// Headmenu is shown at the top of each page.  It is the first div in the container
// div, both of which are inserted in the original html file
import { patch, elementOpen, elementClose, elementVoid, text } from 'incremental-dom';
import { isNil } from '../../utils';
import { exportedSiteData } from '../../index';
import './headmenu.scss';
import './menucontent.scss';
// import './topmenu.scss';
import { linkClick } from '../../rxjs';
import { timer } from 'rxjs';
// import { takeWhile, map, filter, first } from 'rxjs/operators';
import { MenuType } from '../../enums';
import { HamburgerIcon } from '../icons/hamburger';
;
// TODO: memoize menu length
var headMenuStore = {
    shorten: 0,
    actual: 0
};
var headMenuShorten = function (by) {
    headMenuStore.shorten = by < 0
        ? 0
        : headMenuStore.shorten > 10
            ? headMenuStore.shorten
            : headMenuStore.shorten + by;
};
var HeadMenu = function (pageChangeObservable, headMenuContent, headerLogo, dropmenu, options) {
    var hm = Object.create({});
    // If the prerendered headmenu is already there don't add it again.
    if (!document.getElementById('headmenuwrapper')) {
        var bwel = document.createElement('div');
        bwel.setAttribute('id', 'headmenuwrapper');
        var pw = document.getElementById('container');
        pw.insertBefore(bwel, pw.firstChild);
        // FIXME: What if there is no firstChild in container?
    }
    ;
    pageChangeObservable.subscribe({
        next: function (ps) {
            var menuContainer = document.getElementById('headmenuwrapper');
            if (menuContainer !== null) {
                patch(menuContainer, function () { return headMenu(headMenuContent, headerLogo, dropmenu, ps.subMenu, { subMenuClass: ps.subMenuClass, afterHeadMenu: options === null || options === void 0 ? void 0 : options.afterHeadMenu }); });
                dropmenu.reset();
            }
        }
    });
    return hm;
};
var headMenuFormattedContent = function (headMenuContent, currentLocation, shorten, menuType) {
    if (menuType === void 0) { menuType = MenuType.Head; }
    elementOpen('div', null, null, 'id', 'menucontent');
    var displayList = headMenuContent
        .filter(function (m) { return ((shorten === 0) || (currentLocation !== m.link)); }) // shorten:1 cuts just the current link
        .filter(function (m) { return (m.priority > shorten); })
        .map(function (m) { return ({ menuText: m.menuText, link: m.link }); });
    if (displayList.length < 2) {
        // NICE: Could also make this open the menu
        elementOpen('p');
        if (exportedSiteData.pageLabels[currentLocation] !== undefined) {
            text(exportedSiteData.pageLabels[currentLocation]);
        }
        else {
            text(currentLocation.split('/').slice(-1)[0]);
        }
        elementClose('p');
    }
    else {
        elementOpen('ul', null, ['id', menuType === MenuType.Top ? 'mclist-top' : 'mclist-head']);
        displayList.map(function (_a, i) {
            var menuText = _a.menuText, link = _a.link;
            elementOpen('li');
            elementOpen('a', "mc-" + i, null, 'href', link, 'class', currentLocation === link ? 'active-link' : 'other-link', 'onclick', function (event) {
                linkClick(event, link);
            });
            text(menuText);
            elementClose('a');
            elementClose('li');
        });
        elementClose('ul');
    }
    elementClose('div');
};
var afterRepaint = function (f) {
    window.requestAnimationFrame(function () { return window.requestAnimationFrame(f); });
};
var windowWidth = window.innerWidth;
// NICE: Move submenu into own component
var subMenuContent = function (subMenu, subMenuClass) {
    if (subMenu.length === 0)
        return;
    elementOpen('div', "sub-menu-" + subMenuClass, ['id', "sub-head-menu", 'class', ["submenu", subMenuClass].filter(function (c) { return c !== undefined; }).join(' ')]);
    elementOpen('ul', "sub-menu-ul", null, 'id', "sub-head-menu-ul");
    subMenu.map(function (_a) {
        var label = _a.label, link = _a.link, shortLabel = _a.shortLabel;
        if (link !== undefined) {
            elementOpen('a', null, null, 'href', link, 'class', window.location.pathname === link ? 'active-link' : 'other-link', 'onclick', function (event) {
                linkClick(event, link);
            });
            elementOpen('li', "sub-menu-li", null);
            text(window.innerWidth > 450 ? label : shortLabel || label);
            elementClose('li');
            elementClose('a');
        }
        else {
            elementOpen('li', "sub-menu-li", null);
            text(label);
            elementClose('li');
        }
    });
    elementClose('ul');
    elementClose('div');
};
// TODO: The menucontent changes when the page changes
var headMenu = function (headMenuContent, headerLogo, dropmenu, subMenu, options) {
    elementOpen('div', null, null, 'class', 'topmenuouter');
    elementVoid('div', null, ['id', 'headsidemenu']);
    elementOpen('div', null, null, 'class', 'topmenubar');
    elementOpen('a', "head-logo", null, 'href', '/', 'class', 'menubarlogolink', 'alt', 'Home Page', 'onclick', function (event) {
        linkClick(event, '/');
    });
    headerLogo();
    elementClose('a');
    elementOpen('div', null, null, 'class', 'content', 'id', 'hmc');
    headMenuFormattedContent(headMenuContent, window.location.pathname, headMenuStore.shorten);
    elementClose('div');
    if (dropmenu) {
        HamburgerIcon(function () {
            dropmenu.toggle();
        });
    }
    elementClose('div');
    if (typeof subMenu === 'function') {
        subMenu();
    }
    else {
        subMenuContent(subMenu, options === null || options === void 0 ? void 0 : options.subMenuClass);
    }
    elementVoid('div', null, ['id', 'headsubmenu']);
    if (options === null || options === void 0 ? void 0 : options.afterHeadMenu) {
        elementOpen('div', null, ['class', 'after-head-menu']);
        options.afterHeadMenu();
        elementClose('div');
    }
    elementClose('div');
    // headMenuStore = {actual: 0, shorten: 0};
    // TODO: Start on first idle.
    timer(200)
        .subscribe(function () {
        patch(document.getElementById('hmc'), function () {
            headMenuFormattedContent(headMenuContent, window.location.pathname, headMenuStore.shorten);
            afterRepaint(function () { return setHeadMenuWidth(headMenuContent, 0); });
        });
    });
    // patchElement('headsubmenu').style.height = '0px';
    // document.getElementById('headsidemenu').style.right = '-2000px';
    // headMenuStore = { // TODO: Check if this is needed still
    //     show: false,
    //     actual: 0
    // };
    // console.log('killing top menu')
    // headMenuStore = merge(headMenuStore, {show: false, actual: 0});
    // afterRepaint(() => setHeadMenuWidth(headMenuContent, 0));
    // window.requestAnimationFrame(() => setHeadMenuWidth(0));
    // addToPageQueue({
    //     run: function loadPix() {
    //         console.log('headMenuStore.shorten')
    //         afterRepaint(() => setHeadMenuWidth(headMenuContent, 0));
    //     }, name: 'hmcShorten', holdFor: [{
    //         event: KernelEvent.itemPatched,
    //         item: 'hmcContent'
    //     }]});
    var resizeThrottle = undefined; //TODO: fix type
    window.addEventListener('resize', function (e) {
        //   console.log('resize event')
        // NICE: remove flash after resize
        if (!isNil(resizeThrottle)) {
            clearTimeout(resizeThrottle);
        }
        resizeThrottle = setTimeout(function () {
            if (window.innerWidth !== windowWidth) { // Don't reflow if only height changes (iPad menubar reveal)
                windowWidth = window.innerWidth;
                headMenuShorten(-1);
                var hmc = document.getElementById('hmc');
                patch(hmc, function () { return headMenuFormattedContent(headMenuContent, window.location.pathname, headMenuStore.shorten); });
                afterRepaint(function () { return setHeadMenuWidth(headMenuContent, 0); });
                //   window.requestAnimationFrame(() => setHeadMenuWidth(0));
            }
            resizeThrottle = undefined;
            // topMenuShow(false);
        }, 100);
    });
};
var setHeadMenuWidth = function (headMenuContent, loopctr) {
    if (loopctr === void 0) { loopctr = 0; }
    // console.log(`Setting menu width hms: ${headMenuStore.shorten}`)
    var el = document.getElementById('mclist-head');
    if (el !== null) {
        var el2 = el.firstChild;
        if (el2 !== null) {
            // console.log(`menu: ${el.offsetLeft} ${el2.offsetLeft}`);
            // console.log(`menu: ${el.offsetWidth} ${el2.offsetWidth}`);
            if (el2.offsetWidth > (el.offsetWidth - 40)) {
                // console.log('No room for menu');
                var hmc = document.getElementById('hmc');
                patch(hmc, function () { });
            }
            else if (el2.offsetLeft < el.offsetLeft) {
                // console.log(`xMenu Overflowing by: ${(el.offsetLeft-el2.offsetLeft)} loop: ${loopctr} hms: ${headMenuStore.shorten}`);
                headMenuShorten(1);
                var hmc = document.getElementById('hmc');
                patch(hmc, function () { return headMenuFormattedContent(headMenuContent, window.location.pathname, headMenuStore.shorten); });
                afterRepaint(function () { return setHeadMenuWidth(headMenuContent, loopctr + 1); });
                // window.requestAnimationFrame(() => setHeadMenuWidth(loopctr+1));
            }
        }
    }
};
export { HeadMenu, headMenuFormattedContent, // Used in scrollmenu
 };
//# sourceMappingURL=index.js.map